const user = JSON.parse(sessionStorage.getItem('user'));
// const accessToken = JSON.parse(sessionStorage.getItem('accessToken'));
// const user = {};
// user.accessToken = accessToken;
export default user;
